<template>
  <div>
    <info-list
      :form-model="formModel"
      :headers="headers"
    ></info-list>
  </div>
</template>

<script>
import InfoList from '@/modules/bankruptcy/components/bankruptcy-file/info-list.vue';
import { toHijriDate, toGeorgianDateString } from '@/helpers/utils';

export default {
  components: { InfoList },
  props: {
    formModel: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      toHijriDate,
      toGeorgianDateString,
      headers: [
        {
          key: 'identityTypeName',
          text: this.local.bankruptcy.requestDetails.bankruptDueRights.identityType,
        },
        {
          key: 'identityNumber',
          text: this.local.bankruptcy.requestDetails.bankruptDueRights.identityNumber,
        },
        {
          key: 'dateOfBirth',
          text: this.local.bankruptcy.requestDetails.bankruptDueRights.dateOfBirth,
          formatter: toHijriDate,
        },
        {
          key: 'fullName',
          text: this.local.bankruptcy.requestDetails.bankruptDueRights.name,
        },
        {
          key: 'commercialRegistrationNumber',
          text: this.local.bankruptcy.requestDetails.bankruptDueRights.commercialRegistrationNumber,
        },
        {
          key: 'unifiedNumber',
          text: this.local.bankruptcy.requestDetails.bankruptDueRights.unifiedNumber,
        },
        {
          key: 'managerFullName',
          text: this.local.bankruptcy.requestDetails.bankruptDueRights.managerFullName,
        },
        {
          key: 'mobile',
          text: this.local.bankruptcy.requestDetails.bankruptDueRights.mobile,
        },
        {
          key: 'email',
          text: this.local.bankruptcy.requestDetails.bankruptDueRights.email,
        },
        {
          key: 'debtValue',
          text: this.local.bankruptcy.requestDetails.bankruptDueRights.debtValue,
        },
        {
          key: 'dueDate',
          text: this.local.bankruptcy.requestDetails.bankruptDueRights.dueDateHijri,
          formatter: toHijriDate,
        },
        {
          key: 'dueDate',
          text: this.local.bankruptcy.requestDetails.bankruptDueRights.dueDateGregorian,
          formatter: toGeorgianDateString,
        },
        {
          key: 'debtOrigin',
          text: this.local.bankruptcy.requestDetails.bankruptDueRights.debtOrigin,
        },
        {
          key: 'countryName',
          text: this.local.bankruptcy.requestDetails.bankruptDueRights.countryId,
        },
        {
          key: 'cityName',
          text: this.local.bankruptcy.requestDetails.bankruptDueRights.cityId,
        },
        {
          key: 'isGuaranteed',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.isGuaranteed,
          formatter: (val) => { return val ? this.local.common.yes : this.local.common.no; },
        },
        {
          key: 'guaranteeType',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.guaranteeType,
        },
        {
          key: 'managerFullName',
          text: this.local.bankruptcy.requestDetails.partners.managerName,
        },
        {
          key: 'managerIdentityNumber',
          text: this.local.personInformation.socialId,
        },
        {
          key: 'passportDate',
          text: this.local.personInformation.passportDate,
        },
        {
          key: 'passportSource',
          text: this.local.personInformation.passportSource,
        },
      ],
    };
  },
  computed: {},
  mounted() {

  },
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>
